import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class Repository {
  _URL: string;
  ApiKey: string;
  constructor(private _Http: HttpClient, private _cookieService: CookieService) {
    this._URL = environment.apiUrl;
    this.ApiKey = environment.apiKey;

  }
  //with Credentials repository calls

  headerWithParameter() {
    let email: any = localStorage.getItem('repEmail')
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const { token, role } = user;
    var headers = new HttpHeaders()
      .set("Content-Type", "application/json; charset=utf-8")
      .set("apikey", this.ApiKey)
      .set(email ? 'EmailId' : 'MobileNo', email ? JSON.parse(email) : this._cookieService.get('KYCUserId'))
      .set('Token', token)
    return headers;
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error)
  }

  postMethodWithHeaderParamWC(api: any, data: any) {
    var postdata = JSON.stringify(data);
    const headers = this.headerWithParameter();
    const options = { headers, withCredentials: false };
    return this._Http.post(this._URL + api, postdata, options).pipe(catchError(this.handleError));
  }

  getmethodWC(api: any) {
    const headers = this.headerWithParameter();
    const options = { headers, withCredentials: false };
    return this._Http.get(this._URL + api, options).pipe(catchError(this.handleError));
  }

  headerWithParameter_WithoutToken() {
    var headers = new HttpHeaders()
      .set("Content-Type", "application/json; charset=utf-8")
      .set("apikey", this.ApiKey)
      .set('MobileNo', this._cookieService.get('KYCUserId'))
    return headers;
  }

  postMethodWithHeaderParamWC_WithoutToken(api: any, data: any) {
    var postdata = JSON.stringify(data);
    const headers = this.headerWithParameter_WithoutToken();
    const options = { headers, withCredentials: false };
    return this._Http.post(this._URL + api, postdata, options).pipe(catchError(this.handleError));
  }

  headerWithParameter_WithoutTokenracking() {
    var headers = new HttpHeaders()
      .set("Content-Type", "application/json; charset=utf-8")
      .set("apikey", this.ApiKey)
    return headers;
  }
  postMethodWithHeaderParamWC_WithoutTokenTracking(api: any, data: any) {
    var postdata = JSON.stringify(data);
    const headers = this.headerWithParameter_WithoutTokenracking();
    const options = { headers, withCredentials: false };
    return this._Http.post(this._URL + api, postdata, options).pipe(catchError(this.handleError));
  }
}